<script lang="ts">
  import type { Accordion } from '$lib/sanity/schemas';
  import AccordionItem from './AccordionItem.svelte';
  import { type ContentSourceMap, type StudioPathLike } from '@sanity/svelte-loader';

  interface Props {
    document: Accordion;
    sourceMap: ContentSourceMap;
    path?: StudioPathLike;
  }

  let { document, sourceMap, path = [] }: Props = $props();
</script>

<div>
  {#each document.items ?? [] as item, index}
    {#if item}
      <AccordionItem document={item} {sourceMap} path={[...path, 'items', index]} />
    {/if}
  {/each}
</div>

<style lang="scss">
  div {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
</style>
